import useParentLoaderData from "../../../../../hooks/useParentLoaderData";
import useService from "../../../../../hooks/useService";
import { getModalHandler } from "../../../Common/Modals/hooks/useModalSingleton";
import { useServicesStore } from "../store/services-provided/servicesStore";
import STRINGS from "../utils/strings";

import { useResetAllStores } from "./useResetAllStores";

export default function useServicesButtonActions() {
  const servicesRepository = useService("repositories/service-repository");
  const { id } = useParentLoaderData(2);
  const {
    selectedAvailableServices,
    setSelectedAvailableServices,
    selectedProvidedServices,
    setSelectedProvidedServices,
    servicesToBeAdded,
    setServicesToBeAdded,
    servicesToBeRemoved,
    setServicesToBeRemoved,
  } = useServicesStore();

  const { resetAllStores } = useResetAllStores();
  const { openSuccessModal, openFailureModal } = getModalHandler();

  const handleOnClickLeftNavigation = () => {
    const servicesToRemove = [...selectedProvidedServices];

    setServicesToBeRemoved([
      ...servicesToBeRemoved,
      ...selectedProvidedServices.filter((s) => s.serviceType !== STRINGS.SERVICE_TYPE.AVAILABLE),
    ]);

    const idsToRemove = new Set(servicesToRemove.map((s) => s.id ?? s.service?.id));

    setServicesToBeAdded(
      servicesToBeAdded.filter((item) => !idsToRemove.has(item.id ?? item.service?.id))
    );

    setSelectedProvidedServices([]);
  };

  const handleOnClickRightNavigation = () => {
    const servicesToAdd = [...selectedAvailableServices];

    setServicesToBeAdded([...servicesToBeAdded, ...servicesToAdd]);

    const idsToAdd = new Set(servicesToAdd.map((s) => s.id ?? s.service?.id));

    setServicesToBeRemoved(
      servicesToBeRemoved.filter((item) => !idsToAdd.has(item.id ?? item.service?.id))
    );

    setSelectedAvailableServices([]);
  };

  const handleOnClickCancelButton = async () => {
    resetAllStores();
  };

  const handleOnClickSaveButton = async () => {
    try {
      const queryParams = {};
      if (id) {
        queryParams.providerId = id;
      }

      if (servicesToBeAdded && servicesToBeAdded.length > 0) {
        const idsToAdd = servicesToBeAdded.map((service) => service.id ?? service.service?.id);
        await servicesRepository.addRemoveService(queryParams, true, idsToAdd);
      }

      if (servicesToBeRemoved && servicesToBeRemoved.length > 0) {
        const idsToRemove = servicesToBeRemoved.map((service) => service.id ?? service.service?.id);
        await servicesRepository.addRemoveService(queryParams, false, idsToRemove);
      }

      openSuccessModal();
      resetAllStores();
    } catch (error) {
      console.error(error);
      openFailureModal(error);
    }
  };

  return {
    handleOnClickCancelButton,
    handleOnClickSaveButton,
    handleOnClickLeftNavigation,
    handleOnClickRightNavigation,
  };
}
